module.exports = __webpack_public_path__ + "static/media/AviationSecurityCert.a565b83d.svg";